import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

type PropsType = {
  children: ReactNode;
  onFocusChange: (focused: boolean) => void;
};

const FocusContainer = ({ children, onFocusChange }: PropsType) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleFocusChange = (event: MouseEvent | FocusEvent) => {
    onFocusChange(
      Boolean(
        event.target instanceof Node &&
          containerRef.current?.contains(event.target),
      ),
    );
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleFocusChange);
    document.addEventListener('focusin', handleFocusChange);
    return () => {
      document.removeEventListener('mousedown', handleFocusChange);
      document.removeEventListener('focusin', handleFocusChange);
    };
  });

  return <div ref={containerRef}>{children}</div>;
};

export default FocusContainer;
